import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-2 border-accent bg-canvasAlt" data-id="element-113" data-mp="ddvetbz589cz">
      <div className="mx-auto max-w-xl px-3 py-6 text-center sm:px-5" data-id="element-114" data-mp="icgglfu1n13j">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-115" data-mp="meaan59qh6uq">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-base font-extrabold leading-tight text-ink sm:text-xl" data-id="element-116" data-mp="rc3l4ai2kn0t">
          Comienza hoy desde cero y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 rounded-xl border-2 border-accent bg-surface p-4" data-id="element-117" data-mp="2y44ebdgvsxne">
          <p className="flex items-center justify-center gap-1.5 font-display text-[0.8rem] font-black uppercase leading-tight text-cyan sm:text-sm" data-id="element-118" data-mp="12niahdk4pxps">
            <LockIcon size={14} className="flex-shrink-0" data-id="element-119" data-mp="xw0bgv1o277g" />
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 font-display text-[0.75rem] font-extrabold uppercase text-ink" data-id="element-120" data-mp="syibvv9jh4c4">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1.5 text-[0.75rem] text-ink-muted" data-id="element-121" data-mp="oual7sjiteb9">
            🎁 Bonos valorados en{' '}
            <span className="font-semibold text-accent" data-id="element-122" data-mp="1lk08udthgvv0">{BONUS_VALUE}</span>
          </p>

          <p className="mt-2 inline-block rounded bg-danger-soft px-2.5 py-0.5 font-display text-[0.62rem] font-black uppercase tracking-wide text-danger" data-id="element-123" data-mp="1gl70ezt1zv1p">
            🔥 Oferta especial
          </p>

          <p className="mt-1 font-display text-3xl font-black leading-none text-accent sm:text-4xl" data-id="element-124" data-mp="17oxwp8y1ma9r">
            Hoy: {PRICE}
          </p>
          <p className="mt-1 text-[0.7rem] font-semibold text-ink-muted" data-id="element-125" data-mp="3sckmb45f46ys">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-126" data-mp="3trwryw36d55r">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-ink-muted" data-id="element-127" data-mp="3ks9qkaag3zcp">
            <span className="flex items-center gap-1" data-id="element-128" data-mp="3ot3gtabd1q8r">
              <ZapIcon size={12} className="text-cyan" data-id="element-129" data-mp="3b388mekcb7w3" />
              Acceso Inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-130" data-mp="3fv9u8r3eeays">•</span>
            <span className="flex items-center gap-1" data-id="element-131" data-mp="3fw1cl07zic74">
              <ShieldCheckIcon size={12} className="text-success" data-id="element-132" data-mp="316n37s4erurq" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}